import React from "react";
import { Helmet } from "react-helmet";
import { useNavigate } from "react-router-dom";
import Loader from "../../components/common/Loader";
import Footer from "../../components/common/Footer";
import Menu from "../../components/common/Menu";
import Navbar from "../../components/common/Navbar";
import StartButton from "../../components/home/StartButton";
import { usePageLoader } from "../../hooks/usePageLoader";

const OrderConfirmation: React.FC = () => {
  usePageLoader(); // Hide loader on mount for client-side navigation

  const navigate = useNavigate();

  return (
    <>
      <Helmet>
        <title>Order Confirmation | Tempe Fabrication</title>
        <link rel="stylesheet" type="text/css" href="/home/assets/css/home_1_style.css" />
        <link rel="stylesheet" type="text/css" href="/innerpages/assets/css/innerpages.css" />
        <script src="/common/assets/js/common_js.js"></script>
        <script src="/innerpages/assets/js/innerpages.js"></script>
      </Helmet>
      <div className="inner-pages-style1">
        <Loader />
        <Menu />
        <div className="smooth-scroll-content" id="scrollsmoother-container">
          <Navbar currentPage="products" />

          <section className="tc-order-confirmation-section" style={{ padding: "100px 0" }}>
            <div className="container">
              <div className="row justify-content-center">
                <div className="col-lg-8">
                  <div style={{
                    textAlign: "center",
                    backgroundColor: "#f9f9f9",
                    padding: "60px 40px",
                    borderRadius: "8px",
                  }}>
                    {/* Success Icon */}
                    <div style={{
                      width: "80px",
                      height: "80px",
                      borderRadius: "50%",
                      backgroundColor: "#28a745",
                      margin: "0 auto 30px",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                    }}>
                      <svg
                        width="40"
                        height="40"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="white"
                        strokeWidth="3"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      >
                        <polyline points="20 6 9 17 4 12"></polyline>
                      </svg>
                    </div>

                    <h1 style={{
                      fontSize: "32px",
                      fontWeight: "600",
                      marginBottom: "15px",
                    }}>
                      Order Confirmed!
                    </h1>

                    <p style={{
                      fontSize: "16px",
                      color: "#666",
                      marginBottom: "30px",
                      lineHeight: "1.6",
                    }}>
                      Thank you for your order. We've received your payment and will begin processing your order shortly.
                      You'll receive an email confirmation with your order details and tracking information once your order ships.
                    </p>

                    <div style={{
                      display: "flex",
                      gap: "15px",
                      justifyContent: "center",
                      flexWrap: "wrap",
                    }}>
                      <button
                        onClick={() => navigate("/products")}
                        className="butn border rounded-pill hover-bg-black"
                        style={{
                          padding: "12px 30px",
                        }}
                      >
                        <span>Continue Shopping</span>
                      </button>

                      <button
                        onClick={() => navigate("/")}
                        className="butn border rounded-pill hover-bg-black bg-orange1 text-white"
                        style={{
                          padding: "12px 30px",
                        }}
                      >
                        <span>Back to Home</span>
                      </button>
                    </div>

                    <div style={{
                      marginTop: "40px",
                      paddingTop: "30px",
                      borderTop: "1px solid #ddd",
                    }}>
                      <p style={{
                        fontSize: "14px",
                        color: "#999",
                        marginBottom: "10px",
                      }}>
                        Questions about your order?
                      </p>
                      <a
                        href="/contact"
                        style={{
                          color: "var(--color-orange1)",
                          textDecoration: "none",
                          fontWeight: "500",
                        }}
                      >
                        Contact Us
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>

          <Footer />
        </div>
        <StartButton />
      </div>
    </>
  );
};

export default OrderConfirmation;
